<div class="img-container">
  <img src="assets/img/{{imageUrl}}" alt="{{imageAlt}}">
</div>
<div [ngClass]="[classSwitch ? 'not-selected' : 'selected', 'text-container']" (click)="classSwitch = !classSwitch;">
  <h3>{{title}}</h3>
  <p>{{description}}</p>
</div>
